import React from "react";
import { CalendarPlus, Clock, Wallet, Trophy } from "lucide-react";

const VALUES = [
  {
    icon: CalendarPlus,
    title: "Generate More Appointments",
    desc: "Consistent outbound activity that fills your pipeline with real opportunities.",
  },
  {
    icon: Clock,
    title: "Improve Customer Response Time",
    desc: "Faster replies across phone, email, and chat — better retention, better reviews.",
  },
  {
    icon: Wallet,
    title: "Reduce Workload & Costs",
    desc: "Trained talent without the full-time payroll, benefits, or management overhead.",
  },
  {
    icon: Trophy,
    title: "Focus on Closing",
    desc: "We handle the outreach and support so your team can concentrate on what pays.",
  },
];

const Value = () => {
  return (
    <section
      id="value"
      data-testid="value-section"
      style={{
        position: "relative",
        padding: "96px 0 144px",
        background: "rgba(8,8,8,0.70)",
        overflow: "hidden",
      }}
    >
      {/* Decorative background */}
      <div style={{ position: "absolute", inset: 0 }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "1px", background: "linear-gradient(90deg, transparent, rgba(210,170,60,0.15), transparent)" }} />
        <div
          style={{
            position: "absolute",
            bottom: "-100px",
            right: "10%",
            width: "500px",
            height: "500px",
            borderRadius: "50%",
            filter: "blur(140px)",
            background: "radial-gradient(circle, rgba(210,170,60,0.06) 0%, transparent 70%)",
            animation: "hero-orb-1 20s ease-in-out infinite",
          }}
        />
      </div>

      <div style={{ position: "relative", maxWidth: "1280px", margin: "0 auto", padding: "0 24px" }}>
        {/* Section header */}
        <div style={{ maxWidth: "640px", marginBottom: "64px" }}>
          <div
            className="reveal"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "10px",
              letterSpacing: "0.4em",
              color: "rgba(210,170,60,0.8)",
              textTransform: "uppercase",
              marginBottom: "20px",
            }}
          >
            The Value
          </div>
          <h2
            className="reveal reveal-delay-1"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: "clamp(36px, 5vw, 60px)",
              fontWeight: 300,
              lineHeight: 1.08,
              color: "#fff",
              letterSpacing: "0.02em",
            }}
          >
            What this{" "}
            <em style={{ color: "#e8c45a", fontStyle: "italic", fontWeight: 400 }}>actually delivers</em>.
          </h2>
        </div>

        {/* Value cards */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "24px" }}>
          {VALUES.map((v, i) => (
            <div
              key={v.title}
              data-testid={`value-card-${i}`}
              className="reveal"
              style={{
                padding: "36px 32px",
                background: "rgba(12,12,12,0.6)",
                border: "1px solid rgba(255,255,255,0.06)",
                transition: "all 0.35s ease",
                animationDelay: `${i * 90}ms`,
                cursor: "default",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "rgba(210,170,60,0.25)";
                e.currentTarget.style.background = "rgba(14,14,14,0.8)";
                e.currentTarget.style.transform = "translateY(-4px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.06)";
                e.currentTarget.style.background = "rgba(12,12,12,0.6)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <div
                style={{
                  width: "44px",
                  height: "44px",
                  border: "1px solid rgba(210,170,60,0.2)",
                  background: "rgba(210,170,60,0.04)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "24px",
                }}
              >
                <v.icon style={{ width: "20px", height: "20px", color: "#e8c45a" }} />
              </div>
              <h3
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "22px",
                  fontWeight: 400,
                  color: "#fff",
                  lineHeight: 1.25,
                  letterSpacing: "0.01em",
                  marginBottom: "12px",
                }}
              >
                {v.title}
              </h3>
              <p
                style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "12px",
                  fontWeight: 300,
                  color: "rgba(255,255,255,0.5)",
                  lineHeight: 1.7,
                  letterSpacing: "0.01em",
                }}
              >
                {v.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Value;
